export default __webpack_public_path__ + "static/media/pivo-image-cropped.2e1c809a.svg";